module.exports = __webpack_public_path__ + "static/media/detectDataImage10_en.bb6d721a.png";